module.exports = __webpack_public_path__ + "img/1493358276.992aa684.jpg";